import React, { useEffect, useState } from 'react';
import { getRecentSearches, clearRecentSearches, getStorageKey } from '../../utils/recentSearchesStorage';

interface RecentSearchesProps {
  onSearchSelect: (search: string) => void;
}

export default function RecentSearches({ onSearchSelect }: RecentSearchesProps): JSX.Element | null {
  const [searches, setSearches] = useState<string[]>([]);

  useEffect(() => {
    setSearches(getRecentSearches());

    // Handle storage events for multiple tabs
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === getStorageKey()) {
        setSearches(getRecentSearches());
      }
    };

    // Add storage event listener
    window.addEventListener('storage', handleStorageChange);

    // Cleanup function
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleClear = () => {
    clearRecentSearches();
    setSearches([]);
  };

  if (searches.length === 0) {
    return null;
  }

  return (
    <div className="recent-searches-container" style={{
      marginTop: '20px',
      padding: '16px',
      backgroundColor: '#f8f8f8',
      borderRadius: '4px',
      border: '1px solid #eaeded'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h3 style={{ margin: 0 }}>Recent Searches</h3>
        <button 
          onClick={handleClear}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#0073bb', 
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
        >
          Clear all
        </button>
      </div>
      <div>
        {searches.map((search, index) => (
          <a
            key={index}
            href="#"
            onClick={(e) => { 
              e.preventDefault(); 
              onSearchSelect(search); 
            }}
            style={{ 
              color: '#0073bb', 
              backgroundColor: '#f0f6ff',
              padding: '4px 8px',
              borderRadius: '3px',
              textDecoration: 'none',
              display: 'inline-block',
              marginRight: '12px',
              marginBottom: '8px'
            }}
          >
            {search}
          </a>
        ))}
      </div>
    </div>
  );
}